import suggestionquickview from "./suggestion-quickview.html";

const suggestionDb = require('./suggestion-db')
const quickviewHandler = require('../../../../../components/quickview/quickview-handler')
const dtHandler = require('../../../../../components/dt/dt-handler')

/****************ELEMENTS*****************/
var htmlQf = {}
var HTMLwasSelected = false

function HTMLselect(detail) {


      quickviewHandler.HTMLselect(

            'suggestion', //database table name****
            'suggestion-quickview',
            detail.ev.target, //source, for example AC
            suggestionquickview,
            htmlQf)

      HTMLwasSelected = true


}/**/

export function start(detail) {

      if (!HTMLwasSelected) { HTMLselect(detail) }

      obj[detail.act].start(detail)
}/**/

const obj = {

      show: { start: (detail) => { quickviewHandler.show(detail, htmlQf), fill(detail) } },
      hide: { start: (detail) => { quickviewHandler.hide(detail, htmlQf) } },

}/**/

function fill(detail) {
      suggestionDb.load(
            { 'file': `${detail.file}`, 'limit': detail.limit, 'order': detail.order, 'filter': detail.filter },
            async (result) => {
                  const bestColumns = [
                        { key: 'item_name', label: 'Name', format: '', behavior: false, title: true },
                        { key: 'roi', label: 'ROI', format: 'percent', behavior: false, title: true },
                        // star
                        { key: 'roi', label: 'ROI Star', behavior: true, displayText: false, title: true },
                        { key: 'profit', label: 'Profit', format: 'star', behavior: false, title: true },
                        // star
                        { key: 'profit', label: 'Profit Star', behavior: true, displayText: false, title: true }
                  ];

                  if (result.data[0].provider_name || result.data[0].customer_name) {
                        const isCustomer = !result.data[0].provider_name;
                        const clientCol = {
                              key: isCustomer ? 'customer_name' : 'provider_name',
                              label: isCustomer ? 'Customer' : 'Provider',
                              format: '',
                              behavior: false,
                              title: ""
                        };

                        bestColumns.splice(1, 0, clientCol);
                  }

                  const bestTable = await dtHandler.dtSimpleFc(result.data, bestColumns);

                  const titleQuickview = document.querySelector('#title-suggestion-quickview');
                  const date = new Date();
                  const monthName = date.toLocaleString('en-US', { month: 'long' });
                  titleQuickview.innerHTML = ""
                  titleQuickview.innerHTML = `Items history`

                  // title
                  const title = document.querySelector('#title-suggestion-table-quickview');
                  title.innerHTML = ""
                  title.innerHTML = result.data[0].label_suggestion
                  // table
                  const cont = document.querySelector('#suggestion-quickview-best-items');
                  cont.innerHTML = ""
                  cont.innerHTML = bestTable
            }
      )
}